<template>
  <el-button
    :class="classValue"
    :style="clsStyle"
    :type="type"
    :icon="activeIcon"
    :size="size"
    :disabled="isViewOnly()"
    :text="btnStyle === 'text' ? true : false"
    :plain="btnStyle === 'plain' ? true : false"
    :round="round"
    :circle="circle"
    @click="onClick">
      &nbsp;<slot v-if="this.$slots && !this.isEmptyObject(this.$slots)"></slot>
      <span v-else>
        &nbsp;{{text}}
      </span>
  </el-button>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'

export default {
  name: 'download-button',

  mixins: [PostMixins],

  props: {
    url: {
      type: String,
      required: true
    },

    text: {
      type: String,
      default: 'Download'
    },

    cls: {
      type: String,
      default: null
    },

    clsStyle: {
      type: String,
      default: null
    },

    textColor: {
      type: String,
      default: null
    },

    backgroundColor: {
      type: String,
      default: null
    },

    icon: {
      type: String,
      default: 'fa fa-download'
    },

    spiningIcon: {
      type: String,
      default: 'fa fa-spinner fa-spin'
    },

    btnStyle: {
      type: String,
      validator: function (value) {
        return value !== null ? ['text', 'plain', 'primary', 'success', 'info', 'warning'].indexOf(value) !== -1 : true
      },
      default: 'info'
    },
    round: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },

    type: {
      type: String,
      validator: function (value) {
        return value !== null ? ['info', 'primary', 'success', 'warning', 'danger'].indexOf(value) !== -1 : true
      },
      default: null
    },

    timer: {
      type: Number,
      default: 3,
      validator: function (value) {
        if (value >= 1 && value <= 7) {
          return true
        } else {
          return false
        }
      }
    }
  },

  methods: {
    resetIcon () {
      this.activeIcon = this.icon
    },

    setSpinner () {
      setTimeout(this.resetIcon, this.duration)
      var dwUrl = this.getEndpoint(this.url)
      this.downloadFile(dwUrl)
    },

    onClick () {
      this.activeIcon = this.spiningIcon
      this.$message({message: 'Your download will start shortly', type: 'info'})
      setTimeout(this.setSpinner, 1500)
    }
  },

  data () {
    return {
      activeIcon: this.icon,
      classValue: (this.cls ? this.cls + ' ' : '') + (this.textColor ? 'color:' + this.textColor + '; ' : '') + (this.backgroundColor ? 'background-color: ' + this.backgroundColor + ';' : ''),
      duration: this.timer * 1000
    }
  },

  mounted () {
//    console.log('class: ', this.classValue, this.text, this.$slots)
  }
}


</script>



// WEBPACK FOOTER //
// DownloadButton.vue?6cfdb68e